const KEY = "lastRoutes";

const getAll = () => {
  const data = localStorage.getItem(KEY);
  return data ? JSON.parse(data) : {};
};

const setAll = (data) => {
  localStorage.setItem(KEY, JSON.stringify(data));
};

export const saveRoute = (section, route) => {
  const all = getAll();

  all[section] = route;

  setAll(all);
};

export const getRoute = (section) => {
  const all = getAll();
  return all[section] || null;
};

export const clearRoute = (section) => {
  const all = getAll();

  delete all[section];

  setAll(all);
};
